import { NextApiResponse } from 'next';

import type { MasonryResponseModel } from 'templates/Categories/types';

export type CollectionsPopupProps = {
  isMobile: boolean;
  setMasonryData?: (
    data: ((data: MasonryResponseModel) => MasonryResponseModel) | MasonryResponseModel,
  ) => void;
  handleCreateNewCollectionClick?: (viewState: COLLECTIONS_VIEW_STATE_TYPES) => void;
};

export type CollectionProps = {
  withSearchBox: boolean;
  viewState: COLLECTIONS_VIEW_STATE_TYPES;
  onClose: () => void;
  handleDoneClick: () => void;
};

export type FooterProps = {
  onClose: () => void;
  onDone: () => void;
  viewState: COLLECTIONS_VIEW_STATE_TYPES;
};

export type InfoBoxProps = {
  padding?: string;
};

export type CollectionContentProps = {
  viewState?: COLLECTIONS_VIEW_STATE_TYPES;
  // TODO refactor this part
  viewType?: COLLECTIONS_VIEW_STATE_TYPES;
  handleCreateNewCollectionClick?: (viewState: COLLECTIONS_VIEW_STATE_TYPES) => void;
  marginTop?: string;
  padding?: string;
};

export enum COLLECTIONS_VIEW_STATE_TYPES {
  COLLECTIONS,
  NO_SEARCH_RESULT,
  EMPTY_COLLECTIONS,
  NEW_COLLECTION,
}

type DriveResponseProps = {
  uid?: string;
};

type API_ERROR_RESPONSE = {
  status: string;
  response?: DriveResponseProps;
  reason: string;
  message: string;
  actionable_message: {
    text: string;
    action: string;
    action_title: string;
  };
};

type API_SUCCESS_RESPONSE = {
  response?: DriveResponseProps;
  message: string;
};

export type API_RESPONSE =
  | API_ERROR_RESPONSE
  | (NextApiResponse & { response?: DriveResponseProps })
  | API_SUCCESS_RESPONSE;
